export const skills = {
  frontend: {
    title: 'Frontend',
    skills: [
      'React.js',
      'React Native',
      'Next.js',
      'Vue.js',
      'Nuxt.js',
      'Angular',
      'Ionic Framework',
      'Flutter',
      'HTML5',
      'CSS3',
      'Sass',
      'JavaScript (ES6+)',
      'TypeScript',
      'Tailwind CSS',
      'Redux, NgRx, Vuex',
    ],
  },

  backend: {
    title: 'Backend',
    skills: [
      'Node.js',
      'Express',
      'NestJs',
      'PHP',
      'Laravel',
      'Symfony',
      'C#',
      '.NET',
      'ASP.NET Core',
      'Java',
      'Spring Boot',
      'Python',
      'Django',
      'RESTful APIs',
      'GraphQL',
      'Entity Framework',
      'Dapper',
      'Wordpress',
    ],
  },
  // database: {
  //   title: 'Database & Blockchain',
  //   skills: [
  //     'SQL Server',
  //     'MySQL',
  //     'PostgreSQL',
  //     'MongoDB',
  //     'Firebase',
  //     'Supabase',
  //     'SQLAlchemy',
  //     'pgAdmin',
  //     'Solidity',
  //     'Truffle',
  //     'Hardhat',
  //     'Web3.js',
  //     'Ethers.js',
  //     'IPFS',
  //   ],
  // },

  // devops: {
  //   title: 'DevOps & Cloud',
  //   skills: [
  //     'AWS',
  //     'GCP',
  //     'Azure',
  //     'Docker',
  //     'Kubernetes',
  //     'Jenkins',
  //     'CI/CD',
  //     'GitLab CI',
  //     'Azure DevOps',
  //     'DigitalOcean',
  //   ],
  // },

  // testing: {
  //   title: 'Testing & Debugging',
  //   skills: [
  //     'xUnit',
  //     'Jest',
  //     'Mocha',
  //     'NUnit',
  //     'Cypress',
  //     'Jasmine',
  //     'Selenium',
  //     'Chrome DevTools',
  //     'Postman',
  //     'Swagger',
  //   ],
  // },

  // VersionControl: {
  //   title: 'Version Control & SDLC',
  //   skills: [
  //     'Git',
  //     'GitHub',
  //     'GitLab',
  //     'Bitbucket',
  //     'Scrum',
  //     'SOLID principles',
  //     'Kanban',
  //     'Jira',
  //     'Trello',
  //     'Confluence',
  //   ],
  // },
};
